import * as React from "react";

function SvgChevronRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.586 8L4.293 2.707l1.414-1.414L12.414 8l-6.707 6.707-1.414-1.414L9.586 8z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgChevronRight;
